__turbopack_context__.v({
  "column": "StickyPulse-module__Iqf_AW__column",
  "footerFade": "StickyPulse-module__Iqf_AW__footerFade",
  "rail": "StickyPulse-module__Iqf_AW__rail",
  "sticky": "StickyPulse-module__Iqf_AW__sticky",
  "topBlurBar": "StickyPulse-module__Iqf_AW__topBlurBar",
});
